import React from 'react';

const TabNonSwipeableArea = ({ onTouchStart = undefined, onTouchEnd = undefined, children }) => (
  <div
    className="ws-ui-tab-non-swipeable-area"
    onTouchStartCapture={onTouchStart}
    onTouchEndCapture={onTouchEnd}
  >
    {children}
  </div>
);

export default TabNonSwipeableArea;
